import ALL from "./ALL";
import { HEIGHTS_WITHOUT_XL } from "./heights";
export default [
  {
    code: "06",
    name: "06 - Black Metal Parts",
    description: `Metal parts coated in black powder coated finish for standard working environments.`,
    seat: ALL,
    back: ALL,
    base: ["A", "W", "R", "S", "TUH", "G", "A18", "A24", "A30", "P"],
    height: HEIGHTS_WITHOUT_XL,
    casters: ["RC", "CG", "R", "LRO", "HG", "IPR", "GL"],
    control: [
      "PM",
      "T",
      "FFAC",
      "E3",
      "EXE",
      "T:SLD",
      "FFAC:SLD",
      "EXE:SLD",
      "S",
      "Z",
      "P",
      "X",
      "L",
      "IP",
    ],
    footring: ALL,
    arm: ALL,
    vinylUnderwrap: ALL,
    memoryFoam: ALL,
    series: ALL,
    upholstery: [
      "P28540",
      "P28605",
      "P28542",
      "NH333",
      "NH369",
      "XBLK",
      "BLACK",
      "BLUE",
      "MAPLE",
      "XTBLK",
      "XTBLU",
    ],
    market: ["education", "industrial", "laboratory", "healthcare", "office"],
    powderCoat: ALL,
  },
  {
    code: "C",
    name: "C - Chrome Plated Metal Parts",
    formerly: "T",
    description: `Appropriate metal parts are chrome-plated to stand up to the rigors of technical work areas.`,
    seat: ALL,
    back: ["MB", "TB", "E", "M", "T", "C", "L", "U", "G", "W", "X", "P", "B"],
    base: ["A", "W", "R", "S", "TUH", "C", "A18", "A24", "A30", "G"],
    height: HEIGHTS_WITHOUT_XL,
    casters: ["RC", "CG", "R", "LRO", "HG", "GL", "CRC"],
    control: [
      "PM",
      "T",
      "FFAC",
      "E3",
      "EXE",
      "T:SLD",
      "FFAC:SLD",
      "EXE:SLD",
      "S",
      "Z",
      "P",
      "FA",
      "X",
      "L",
    ],
    footring: ALL,
    arm: ["3D", "ARS", "PSAS", "XA"],
    vinylUnderwrap: ALL,
    memoryFoam: ALL,
    series: ALL,
    upholstery: [
      "P28540",
      "P28605",
      "P28542",
      "NH333",
      "NH369",
      "XBLK",
      "BLACK",
      "BLUE",
      "MAPLE",
      "XTBLK",
      "XTBLU",
    ],
    market: ["education", "industrial", "laboratory", "healthcare", "office"],
    powderCoat: ALL,
    price: [
      {
        component: "series",
        code: ["MVMT"],
        price: 11,
      },
      {
        component: "series",
        code: ["MTCL"],
        price: 65,
      },
      {
        component: "series",
        code: ["MTHD"],
        price: 140,
      },
      {
        component: "series",
        code: ["AJ"],
        price: 65,
      },
      {
        component: "seat",
        code: ["L"],
        price: 0,
      },
      {
        component: "seat",
        code: ["TX"],
        price: 54,
      },
      {
        matchAll: [
          {
            component: "base",
            code: ["A", "R", "W"],
          },
          {
            component: "back",
            code: ["X"],
          },
        ],
        price: 65,
      },
      {
        matchAll: [
          {
            component: "base",
            code: ["A", "R", "W"],
          },
          {
            component: "back",
            code: ALL,
          },
        ],
        price: 65,
      },
      {
        matchAll: [
          {
            component: "base",
            code: ["S"],
          },
          {
            component: "back",
            code: ["X"],
          },
        ],
        price: 124,
      },
      {
        matchAll: [
          {
            component: "base",
            code: ["S"],
          },
          {
            component: "back",
            code: ALL,
          },
        ],
        price: 140,
      },
    ],
  },
  {
    code: "K",
    name: "K - ESD",
    description: `All chair components treated to assure grounding through the chair to ESD flooring or mat. This
      includes the use of conductive casters or glides, metal bases, ground control lead to assure thorough static drain
      if casters become insulated by dirt or dust, ESD upholstery materials, and metal-to-metal contact throughout the
      chair for all metal parts.`,
    seat: ["1", "1F", "1B", "A", "B", "E", "F", "H", "U", "G", "T", "R"],
    back: ["MB", "TB", "E", "M", "T", "C", "L", "U", "G", "X", "B", "S"],
    base: ["A", "W", "S", "TUH", "P", "C"],
    height: ALL,
    casters: ["RK", "HG", "GL", "IPR"],
    control: ["PM", "T", "FFAC", "E3", "EXE", "T:SLD", "FFAC:SLD", "EXE:SLD", "S", "IP"],
    footring: ALL,
    arm: ALL,
    vinylUnderwrap: ALL,
    memoryFoam: ALL,
    series: ALL,
    upholstery: ["GEBONY", "GNAVY", "BLACK", "BLUE", "MBLK", "MBLU", "XTBLK", "XTBLU"],
    market: ["staticControl", "industrial", "laboratory"],
    price: [
      {
        component: "series",
        code: ["MVMT"],
        price: 508,
      },
      {
        component: "series",
        code: ["MTCL", "MTHD"],
        price: 308,
      },
      {
        component: "series",
        code: ALL,
        price: 308,
      },
    ],
    powderCoat: ALL,
  },

  {
    code: "ISO8",
    name: "ISO Class 8 (Black)",
    formerly: "8",
    description: `All chair parts are selected to assure ISO class 8 clean room compatibility.`,
    seat: ["1", "1F", "1B", "A", "B", "E", "U", "G", "K"],
    back: ["MB", "TB", "E", "M", "T", "U", "G", "X", "B"],
    base: ["A", "W", "R", "S", "TUH"],
    height: HEIGHTS_WITHOUT_XL,
    casters: ["RC", "CG", "R", "LRO", "HG", "GL"],
    control: ["PM", "T", "FFAC", "E3", "T:SLD", "FFAC:SLD", "EXE:SLD", "EXE", "P"],
    footring: ALL,
    arm: ["3D", "ARS", "PSAS", "XA"],
    vinylUnderwrap: ALL,
    memoryFoam: ALL,
    series: ALL,
    upholstery: ["P28540", "P28605", "P28542", "XBLK", "BLACK", "BLUE", "XTBLK", "XTBLU"],
    market: ["cleanRoom"],
    powderCoat: ALL,
    price: 27,
  },

  {
    code: "ISO8C",
    name: "ISO Class 8 (Chrome)",
    description: `All chair parts are selected to assure ISO class 8 clean room compatibility. Uses chrome parts.`,
    seat: ["1", "1F", "1B", "A", "B", "E", "U", "G", "K"],
    back: ["MB", "TB", "E", "M", "T", "U", "G", "X", "B"],
    base: ["A", "W", "R", "S", "TUH"],
    height: HEIGHTS_WITHOUT_XL,
    casters: ["RC", "CG", "R", "LRO", "HG", "GL"],
    control: ["PM", "T", "FFAC", "E3", "T:SLD", "FFAC:SLD", "EXE:SLD", "EXE", "P"],
    footring: ALL,
    arm: ["3D", "ARS", "PSAS", "XA"],
    vinylUnderwrap: ALL,
    memoryFoam: ALL,
    series: ALL,
    upholstery: ["P28540", "P28605", "P28542", "XBLK", "BLACK", "BLUE", "XTBLK", "XTBLU"],
    market: ["cleanRoom"],
    powderCoat: ALL,
    price: 27,
  },
  {
    code: "ISO8K",
    description: `All chair parts are selected to assure ISO class 8 clean room compatibility, plus ESD treatment as
      described in performance package "K".`,
    name: "ISO Class 8 / ESD",
    formerly: "8K",
    seat: ["1", "1F", "1B", "A", "B", "E", "U", "G"],
    back: ["MB", "TB", "E", "M", "T", "U", "G", "B"],
    base: ["A", "W", "S", "TUH"],
    height: HEIGHTS_WITHOUT_XL,
    casters: ["RK", "HG", "GL"],
    control: ["PM", "T", "FFAC", "E3", "T:SLD", "FFAC:SLD", "EXE:SLD", "EXE"],
    footring: ALL,
    arm: ["3D", "ARS", "PSAS", "XA"],
    vinylUnderwrap: ALL,
    memoryFoam: ALL,
    series: ALL,
    upholstery: ["MBLU", "MBLK", "BLACK", "BLUE", "XTBLK", "XTBLU"],
    market: ["cleanRoomStaticControl"],
    powderCoat: ALL,
    price: [
      {
        component: "series",
        code: ["MVMT"],
        price: 535,
      },
      {
        component: "series",
        code: ["MTCL", "MTHD"],
        price: 335,
      },
      {
        component: "series",
        code: ALL,
        price: 335,
      },
    ],
  },
  {
    code: "ISO7",
    description: `All chair parts are selected to assure ISO class 7 clean room compatibility, including vinyl
      underwrap of seat bottom.`,
    name: "ISO Class 7 (Black)",
    formerly: "7",
    seat: ["1", "1F", "1B", "A", "B", "E", "U", "G", "K"],
    back: ["MB", "TB", "E", "M", "T", "U", "G", "X", "B"],
    base: ["A", "W", "R", "S", "TUH"],
    height: HEIGHTS_WITHOUT_XL,
    casters: ["RC", "CG", "R", "LRO", "HG", "GL"],
    control: ["PM", "T", "FFAC", "E3", "T:SLD", "FFAC:SLD", "EXE:SLD", "EXE", "P"],
    footring: ALL,
    arm: ["3D", "ARS", "PSAS", "XA"],
    vinylUnderwrap: ALL,
    memoryFoam: ALL,
    series: ALL,
    upholstery: ["P28540", "P28605", "P28542", "XBLK", "BLACK", "BLUE", "XTBLK", "XTBLU"],
    market: ["cleanRoom"],
    powderCoat: ALL,
    price: 54,
  },
  {
    code: "ISO7C",
    description: `All chair parts are selected to assure ISO class 7 clean room compatibility, including vinyl
      underwrap of seat bottom. Uses chrome parts.`,
    name: "ISO Class 7 (Chrome)",
    seat: ["1", "1F", "1B", "A", "B", "E", "U", "G", "K"],
    back: ["MB", "TB", "E", "M", "T", "U", "G", "X", "B"],
    base: ["A", "W", "R", "S", "TUH"],
    height: HEIGHTS_WITHOUT_XL,
    casters: ["RC", "CG", "R", "LRO", "HG", "GL"],
    control: ["PM", "T", "FFAC", "E3", "T:SLD", "FFAC:SLD", "EXE:SLD", "EXE", "P"],
    footring: ALL,
    arm: ["3D", "ARS", "PSAS", "XA"],
    vinylUnderwrap: ALL,
    memoryFoam: ALL,
    series: ALL,
    upholstery: ["P28540", "P28605", "P28542", "XBLK", "BLACK", "BLUE", "XTBLK", "XTBLU"],
    market: ["cleanRoom"],
    powderCoat: ALL,
    price: 55,
  },
  {
    code: "ISO7K",
    description: `All chair parts are selected to assure ISO class 7 clean room compatibility, including vinyl
      underwrap of seat bottom, plus ESD treatment as described in performance package "K".`,
    name: "ISO Class 7 / ESD",
    formerly: "7K",
    seat: ["1", "1F", "1B", "A", "B", "E", "U", "G"],
    back: ["MB", "TB", "E", "M", "T", "U", "G", "B"],
    base: ["A", "W", "S", "TUH"],
    height: HEIGHTS_WITHOUT_XL,
    casters: ["RK", "HG", "GL"],
    control: ["PM", "T", "FFAC", "E3", "T:SLD", "FFAC:SLD", "EXE:SLD", "EXE"],
    footring: ALL,
    arm: ["3D", "ARS", "PSAS", "XA"],
    vinylUnderwrap: ALL,
    memoryFoam: ALL,
    series: ALL,
    upholstery: ["MBLU", "MBLK", "BLACK", "BLUE", "XTBLK", "XTBLU"],
    market: ["cleanRoomStaticControl"],
    powderCoat: ALL,
    price: [
      {
        component: "series",
        code: ["MVMT"],
        price: 562,
      },
      {
        component: "series",
        code: ["MTCL", "MTHD"],
        price: 362,
      },
      {
        component: "series",
        code: ALL,
        price: 362,
      },
    ],
  },
  {
    code: "ISO6",
    name: "ISO Class 6",
    formerly: "1000",
    description: `Also known as "1000". All chair parts are selected to assure ISO class 6 clean room compatibility, including vinyl
      underwrap of seat bottom with filter media.`,
    seat: ["1", "1F", "1B", "A", "B", "E", "U", "G", "VF:R", "C", "T"],
    back: ["MB", "TB", "E", "M", "T", "U", "G", "X", "B"],
    base: ["A", "W", "R", "S", "TUH"],
    height: HEIGHTS_WITHOUT_XL,
    casters: ["RC", "CG", "R", "LRO", "HG", "GL"],
    control: ["PM", "T", "FFAC", "E3", "EXE", "T:SLD", "FFAC:SLD", "EXE:SLD", "S"],
    footring: ALL,
    arm: ["3D", "ARS", "PSAS", "XA"],
    vinylUnderwrap: ALL,
    memoryFoam: ALL,
    series: ALL,
    upholstery: ["P28540", "P28605", "P28542", "XBLK", "BLACK", "BLUE", "XTBLK", "XTBLU"],
    market: ["cleanRoom"],
    powderCoat: ALL,
    price: [
      {
        component: "series",
        code: ["MVMT"],
        price: 76,
      },
      {
        component: "series",
        code: ["MTCL", "MTHD"],
        price: 140,
      },
      {
        component: "series",
        code: ["AJ"],
        price: 81,
      },
      {
        component: "series",
        code: ALL,
        price: 140,
      },
    ],
  },
  {
    code: "ISO6K",
    name: "ISO Class 6 / ESD",
    formerly: "1000-K",
    description: `Also known as "1000-K". All chair parts are selected to assure ISO class 6 clean room compatibility, including vinyl
      underwrap of seat bottom with filter media, plus ESD treatment as described in performance package "K".`,
    seat: ["1", "1F", "1B", "A", "B", "E", "U", "G", "T"],
    back: ["MB", "TB", "E", "M", "T", "U", "G", "X", "B"],
    base: ["A", "W", "S", "TUH"],
    height: HEIGHTS_WITHOUT_XL,
    casters: ["RK", "HG", "GL"],
    control: ["PM", "T", "FFAC", "E3", "EXE", "T:SLD", "FFAC:SLD", "EXE:SLD", "S"],
    footring: ALL,
    arm: ["3D", "ARS", "PSAS", "XA"],
    vinylUnderwrap: ALL,
    memoryFoam: ALL,
    series: ALL,
    upholstery: ["MBLU", "MBLK", "BLACK", "BLUE", "XTBLK", "XTBLU"],
    market: ["cleanRoomStaticControl"],
    powderCoat: ALL,
    price: [
      {
        component: "series",
        code: ["MVMT"],
        price: 583,
      },
      {
        component: "series",
        code: ["MTCL", "MTHD"],
        price: 383,
      },
      {
        component: "series",
        code: ["TX"],
        price: 243,
      },
      {
        component: "series",
        code: ALL,
        price: 383,
      },
    ],
  },
  {
    code: "ISO5",
    name: "ISO Class 5",
    formerly: "VUV",
    description: `Also known as "VUV". All chair parts are selected to assure ISO class 5 clean room compatibility.`,
    seat: ["1F", "1B", "A", "B", "E", "K", "T"],
    back: ["MB", "TB", "E", "M", "T", "X", "B"],
    base: ["A", "W", "S", "TUH"],
    height: HEIGHTS_WITHOUT_XL,
    casters: ["RC", "CG", "R", "LRO", "HG", "GL"],
    control: ["PM", "T", "FFAC", "P", "S"],
    footring: ALL,
    arm: ["3D", "ARS", "PSAS", "XA"],
    vinylUnderwrap: ALL,
    memoryFoam: ALL,
    series: ALL,
    upholstery: ["P28540", "P28605", "P28542", "XBLK", "BLACK", "BLUE", "XTBLK", "XTBLU"],
    market: ["cleanRoom"],
    powderCoat: ["X"],
    price: [
      {
        component: "style",
        code: ["MVMT"],
        price: 281,
      },
      {
        component: "series",
        code: ["AJ"],
        price: 108,
      },
      {
        component: "series",
        code: ["GG"],
        price: 162,
      },
      {
        component: "series",
        code: ["TX", "KX"],
        price: 162,
      },
      {
        component: "series",
        code: ALL,
        price: 281,
      },
    ],
  },
  {
    code: "ISO5K",
    name: "ISO Class 5 / ESD",
    formerly: "VUV-K",
    description: `Also known as "VUV-K". All chair parts are selected to assure ISO class 5 clean room compatibility, plus ESD treatment as
      described in performanc package "K".`,
    seat: ["1F", "1B", "A", "B", "E", "T"],
    back: ["MB", "TB", "E", "M", "T", "X", "B"],
    base: ["A", "W", "S", "TUH"],
    height: HEIGHTS_WITHOUT_XL,
    casters: ["RK", "HG", "GL"],
    control: ["PM", "T", "FFAC", "S"],
    footring: ALL,
    arm: ["3D", "ARS", "PSAS", "XA"],
    vinylUnderwrap: ALL,
    memoryFoam: ALL,
    series: ALL,
    upholstery: ["MBLU", "MBLK", "BLACK", "BLUE", "XTBLK", "XTBLU"],
    market: ["cleanRoomStaticControl"],
    powderCoat: ["X"],
    price: [
      {
        component: "style",
        code: ["MVMT"],
        price: 524,
      },
      {
        component: "series",
        code: ["TX", "KX"],
        price: 292,
      },
      {
        component: "series",
        code: ALL,
        price: 524,
      },
    ],
  },
  {
    code: "ISO4",
    name: "ISO Class 4",
    formerly: "C10",
    description: `Also known as "C10". Appropriate metal parts are chrome-plated. All chair parts are selected to assure ISO class 4 clean room compatibility.`,
    seat: ["A", "B", "E", "TX", "G", "T"],
    back: ["E", "M", "T", "X", "G", "B"],
    base: ["A", "S", "W", "A18", "A24", "A30", "G"],
    height: HEIGHTS_WITHOUT_XL,
    casters: ["RC", "CG", "R", "LRO", "HG", "GL"],
    control: ["T", "S", "X"],
    footring: ALL,
    arm: ["PSAS", "XA"],
    vinylUnderwrap: ALL,
    memoryFoam: ALL,
    series: ALL,
    upholstery: ["P28540", "P28605", "P28542", "XBLK", "BLACK", "XTBLK", "XTBLU"],
    market: ["cleanRoom"],
    powderCoat: ["X"],
    price: [
      {
        component: "series",
        code: ["AJ"],
        price: 135,
      },
      {
        component: "series",
        code: ["TXG", "TX", "GG", "KX"],
        price: 184,
      },
      {
        component: "series",
        code: ALL,
        price: 389,
      },
    ],
  },
  {
    code: "ISO4K",
    name: "ISO Class 4 / ESD",
    formerly: "C10-K",
    description: `Also known as "C10-K". Appropriate metal parts are chrome-plated. All chair parts are selected to assure ISO class 4 clean room compatibility, plus ESD treatment as described in performance package "K”.`,
    seat: ["A", "B", "E", "T", "G"],
    back: ["E", "M", "T", "X", "G", "B"],
    base: ["A", "S", "W"],
    height: HEIGHTS_WITHOUT_XL,
    casters: ["HG", "RK", "GL"],
    control: ["T", "S"],
    footring: ALL,
    arm: ["PSAS", "XA"],
    vinylUnderwrap: ALL,
    memoryFoam: ALL,
    series: ALL,
    upholstery: ["MBLU", "MBLK", "BLACK", "BLUE", "XTBLK", "XTBLU"],
    market: ["cleanRoomStaticControl"],
    powderCoat: ["X"],
    price: [
      {
        component: "series",
        code: ["TX"],
        price: 313,
      },
      {
        component: "series",
        code: ALL,
        price: 632,
      },
    ],
  },
  {
    code: "ISO3",
    name: "ISO Class 3",
    formerly: "C1",
    description: `Also known as "C1". Appropriate metal parts are chrome-plated. All chair parts are selected to assure ISO class 3 clean room compatibility.`,
    seat: ["1F", "A", "B", "E", "VF:F", "VF:H"],
    back: ["MB", "TB", "E", "M", "T", "B"],
    base: ["A", "W", "S", "TUH"],
    height: HEIGHTS_WITHOUT_XL,
    casters: ["RC", "CG", "R", "LRO", "HG", "GL"],
    control: ["PM", "T", "FFAC"],
    footring: ALL,
    arm: ["3D", "PSAS", "XA"],
    vinylUnderwrap: ALL,
    memoryFoam: ALL,
    series: ALL,
    upholstery: ["P28540", "P28605", "P28542", "XBLK", "XTBLK", "XTBLU"],
    market: ["cleanRoom"],
    powderCoat: ["X"],
    price: 410,
  },
  {
    code: "ISO3K",
    name: "ISO Class 3 / ESD",
    formerly: "C1-K",
    description: `Also known as "C1-K". Appropriate metal parts are chrome-plated. All chair parts are selected to assure ISO class 3 clean room compatibility, plus ESD treatment as described in performance package "K”.`,
    seat: ["1F", "A", "B", "E"],
    back: ["MB", "TB", "E", "M", "T", "B"],
    base: ["A", "W", "S", "TUH"],
    height: HEIGHTS_WITHOUT_XL,
    casters: ["RK", "HG", "GL"],
    control: ["PM", "T", "FFAC"],
    footring: ALL,
    arm: ["3D", "PSAS", "XA"],
    vinylUnderwrap: ALL,
    memoryFoam: ALL,
    series: ALL,
    upholstery: ["MBLU", "MBLK", "XTBLK", "XTBLU"],
    market: ["cleanRoomStaticControl"],
    powderCoat: ["X"],
    price: 653,
  },
];
